export default __webpack_public_path__ + "src/images/btn_change_undergraduate-ad8737.png";